import * as React from 'react'
import { DiscountBanner } from '@components/discounts/discount-banner'

export const AugustDiscountBanner = (): JSX.Element => {
  return (
    <DiscountBanner
      discountType="august-discount"
      modal="AugustDiscountModal"
      date="od 01.08 do 16.08"
      image={require('@assets/images/black-week-discount.webp')}
      text={
        <>
          <span style={{ color: '#EED478' }}>Black Week w sierpniu</span>{' '}
          <span className="text-nowrap">w Holiday Park & Resort!</span>
        </>
      }
    />
  )
}
